/**
 * Packing lists sin commercial invoice — misma lógica que merge en Invoice.js.
 * No depende de GET /packinglists?sin_invoice=1 (falla si la tabla aún no existe).
 */
export function packingListsSinInvoice(packingLists, invoices) {
  const usados = new Set();
  for (const inv of invoices || []) {
    if (inv.id_packing_list != null) usados.add(inv.id_packing_list);
  }
  return (packingLists || []).filter((pl) => !usados.has(pl.id_packing_list));
}
